import { Model } from 'mobx-rest'

export class providerAccounts extends Model {
    url() {
        return '/providerAccounts'
    }
}
